import React from 'react'
import { useAuth } from '../middlewares/auth/auth-context'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

export default function PrivateRoute() {
    const authContext = useAuth()
    const location = useLocation()

    if (!authContext.isLoggedIn) {
        return <Navigate to="/connect" replace state={{ from: location }} />
    }

    return <Outlet />
}
